import { useTranslation } from 'react-i18next';

import {
  ProjectPropertiesMenuItem,
  ProjectPropertiesMenuItemPrefix,
  ProjectPropertiesMenuItemValue,
} from '@/features/projects/project-details/components/layouts/project-properties-menu-layout';
import { ProjectType } from '@/shared/types/api';

export const CategoryItem = ({
  category,
  projectType,
}: {
  category: string;
  projectType: ProjectType;
}) => {
  const { t } = useTranslation('project', { keyPrefix: 'Shared' });
  const { t: level1T } = useTranslation('categories', {
    keyPrefix: 'Level1',
  });
  const { t: level2T } = useTranslation('categories', {
    keyPrefix: 'Level2',
  });

  return (
    <ProjectPropertiesMenuItem>
      <ProjectPropertiesMenuItemPrefix>
        {t('category')}
      </ProjectPropertiesMenuItemPrefix>
      <ProjectPropertiesMenuItemValue>
        {projectType === 'project'
          ? level1T(category as any)
          : level2T(category as any)}
      </ProjectPropertiesMenuItemValue>
    </ProjectPropertiesMenuItem>
  );
};
